import React, {useEffect, useState, useRef} from 'react'
import firebase from '../../firebase/config'
import {Link} from 'react-router-dom';
import moment from 'moment';
// import ModalGuide from '../../components/ModalGuide';
import utils from '../../firebase/utils';
import Compress from "react-image-file-resizer";
import {useLocation} from 'react-router-dom';

function DetailCombo() {

    const data = useLocation()

    let todayDate = moment().format("YYYY-MM-DD")
    let minDate = moment().format("YYYY-MM-DD")
    const [limitDate, setLimitDate] = useState(todayDate)

    function formatDate(d){
        let n = moment(d).format("DD/MM/YYYY")
        setLimitDate(n)
    }

    const [productsTypes, setProductsTypes] = useState([])
    const [palabrasClave, setPalabrasClave] = useState([])
    const [localidades, setLocalidades] = useState([])
    const [species, setSpecies] = useState([])
    const [razas, setRazas] = useState([])
    const [listErrors, setListErrors] = useState([])

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [palabra, setPalabra] = useState("")
    const [localidadId, setLocalidad] = useState("")
    const [soles, setSoles] = useState(0)
    const [btnMessage, setBtnMessage] = useState("Subir combo");

    const [countryInfo, setCountryInfo] = useState({})
    const [user, setUser] = useState({})

    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [finalClientStatus, setFinalClientStatus] = useState(true);
    const [aliadoClientStatus, setAliadoClientStatus] = useState(false);
    const [petPointsStatus, setPetPointsStatus] = useState(false);

    const inputTag = useRef(null)
    const inputSku = useRef(null)
    const inputName = useRef(null)
    const inputDesc = useRef(null)
    const inputWord = useRef(null)
    const inputPeso = useRef(null)
    const inputPrice = useRef(null)
    const inputCantidad = useRef(null)
    const inputMinima = useRef(null)
    const hiddenFileInput = useRef(null);

    const valores = [
      "Unidad",
      "Gramo",
      "Kilo",
      "Mililitro",
      "Litro",
      "Cápsula",
      "Galones",
      "Cajas",
      "Paquetes",
      "Docenas",
      "Libras",
      "Onzas",
    ]

    let errorInputMsg = "Campo requerido"

    const [combo, setCombo] = useState({
        comboId: "",
        status: "",
        titulo: "",
        precio: 0,
        descripcion: "",
        dirigido: "Selección",
        edad: "",
        tipoMascota: "Selección",
    })

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');

    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    async function handleChange(e) {
        var file = e.target.files[0]
        Compress.imageFileResizer(
          file,
          600,
          300,
          "JPEG",
          10,
          0,
          (uri) => {
            setFile(uri)
            console.log(uri)
          },
          "file",
          600,
          300
        )
        setImg(URL.createObjectURL(file))
        setListErrors(listErrors.filter( prev => prev !== "img" ))
    }

    
    const getLocalidades = async(aliadoId) =>{
        let tipos = [];
        await firebase.db.collection('Localidades').where("aliadoId", "==", aliadoId).get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.data())
                tipos.sort()
            })
            setLocalidades(tipos)
        })
    }

    const getProductsTypes = async() =>{
        let tipos = [];
        await firebase.db.collection('tipoProductos').get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.id)
                tipos.sort()
            })
            tipos.pop("Todas")
            setProductsTypes(tipos)
        })
    }
    
    const getPets = async() =>{
        let tipos = [];
        await firebase.db.collection('Especies').get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.id)
                tipos.sort()
            })
            setSpecies(tipos)
        })
    }
    
    const getRazas = async(tipoM) =>{
        let tipos = [];
        await firebase.db.collection('Especies').doc(tipoM).collection("Razas").get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.id)
                tipos.sort()
            })
            setRazas(tipos)
        })
    }
      
    const handleKeyPress = (event) => {
        if(event.key === 'Enter' && palabra !== ""){
            setPalabrasClave([...palabrasClave, palabra])
            inputTag.current.value = ""
        }
    }

    const SuccessComponent = ({msg}) => {
        return (
            <div className="success-alert">
                <span className="material-icons mr-2">done</span>
                {msg}
                <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
            </div>
        )
    }

    const ErrorComponent = ({msg}) => {
      return (
          <div className="error-alert">
              <span className="material-icons mr-2">error</span>
              {msg}
              <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    function checkInputs(o){
        let val = 0
        let array = []
        Object.keys(o).forEach(function(key) {
            if (o[key] === '' || o[key] < 0) {
                val++
                array.push(key)
            }
        });
        if(val > 0){
            setListErrors(array)
            window.scrollTo(0, 0)
        }else{
            // uploadProducto()
            setListErrors([])
            console.log("Todo bien")
        }
    }
        
    async function getValuePetPoint(pais){
        try {
            await firebase.db.collection("Ciudades").doc(pais).get().then((v)=>{
                let precioPP =  parseInt(v.data().valorPunto)
                setSoles(precioPP)
            })
        }catch(e){

        }

    }

    async function getComboData(pid){
        try {
            await firebase.db.collection("Combos").doc(pid).onSnapshot((val)=>{
                setCombo({
                    comboId: val.data()["comboId"] ?? "",
                    urlImagen: val.data()["urlImagen"] ?? "",
                    status: val.data()["status"] ?? "",
                    titulo: val.data()["titulo"] ?? "",
                    precio: val.data()["precio"] ?? 0,
                    descripcion: val.data()["descripcion"] ?? "",
                    dirigido: val.data()["dirigido"] ?? "",
                    edad: val.data()["edad"] ?? "",
                    tipoMascota: val.data()["tipoMascota"] ?? "",
                })
            })
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getLocalidades(val.aliadoId)
          getValuePetPoint(val.pais)
          firebase.getCountryInfo(val.pais).then(async (val) => {
            setCountryInfo(val.data()) 
          })
        });
        getProductsTypes()
        getPets()

        getComboData(data.state.comboId)

    }, [])

    return (
        <div className="main-content-container container-fluid px-4">
            {error && <ErrorComponent msg={errorMsg === "" ? "Todos los campos son requeridos" : errorMsg}/>}
            {success && <SuccessComponent msg={successMsg === "" ? "Combo actualizado exitosamente" : successMsg}/>}

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                    <div className="row align-items-center">
                        <div className="col">
                            <p className="page-title bold"><Link className="color-white light" to="/combos">Combos</Link> <span>Detalle</span> </p>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-1 mb-0 level-1">
                    <div className="row align-items-center justify-content-space-around level-2">
                        <i onClick={()=>{}} className="material-icons color-white display-5 cursor-pointer">help_outline</i>
                    </div>
                </div>
            </div>

            <div className="row no-gutters">
                <div className="col-lg-8">
                    
                    <div className="row no-gutters align-items-center justify-content-spacebetween mb-4">
                        <h4 className="color-primary bold mb-0">Editar combo</h4>
                        <div className="row no-gutters">
                            <div onClick={()=>{ checkInputs(combo) }} 
                            className="btn btn-success">Editar</div>
                        </div>
                    </div>

                    <div className="creation-card mb-3">
                        <div className="creation-card-title">Detalles</div>
                        <div className="creation-card-content">
                            
                            <div className="creation-input-group mb-3 no-gutters">
                                <div className="col-lg-7">
                                    <p className="creation-input-label">Código del combo</p>
                                </div>
                                <div className="col-lg-5">
                                    <input value={combo.promoCode} onChange={(e)=>{setCombo({...combo, promoCode: e.target.value}); }} className={`form-control col-lg-12`} />
                                </div>
                            </div>

                            <div className="creation-input-group mb-3 no-gutters">
                                <div className="col-lg-3">
                                    <p className="creation-input-label">Estado</p>
                                </div>
                                <div className="col-lg-8">
                                    <select value={combo.status} onChange={(e)=>{setCombo({...combo, status: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "status" ) )  }} 
                                    className={`form-control col-lg-12 ${ listErrors.includes("status") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="Activo">Activo</option>
                                        <option value="Borrador">Borrador</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("status") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="creation-input-group-words">

                                <div className="creation-input-group no-gutters mr-2" style={{width: "100%"}}>
                                    <div className="col-lg-5">
                                        <p className="creation-input-label">Etiquetas</p>
                                    </div>
                                    <div className="col-lg-7">
                                        <input ref={inputTag} type="text" onKeyPress={handleKeyPress} onChange={e=>{setPalabra(e.target.value)}}  placeholder="Comida" className="form-control"/>
                                    </div>
                                </div>
                                {palabrasClave.map(p => (
                                    <p className="pill mb-0" key={p}>{p} <span className="cursor-pointer btn-delete" onClick={()=>{ setPalabrasClave(palabrasClave.filter((p1) => p1 !== p)); }} >X</span></p>
                                ))}

                            </div>



                        </div>
                    </div>

                    <div className="creation-card mb-3">
                        <div className="creation-card-title mb-2">Mercado</div>
                        <div className="creation-card-content">
                            
                            <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                <div className="col-lg-3">
                                    <p className="creation-input-label">Edad</p>
                                </div>
                                <div className="col-lg-8">
                                    <select value={combo.edad} onChange={(e)=>{setCombo({...combo, edad: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "edad" ) )  }} className={`form-control col-lg-12 ${ listErrors.includes("edad") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="Cachorro">Cachorro</option>
                                        <option value="Sénior">Sénior</option>
                                        <option value="Adulto">Adulto</option>
                                        <option value="Todos">Todos</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("edad") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                <div className="col-lg-3">
                                    <p className="creation-input-label">Especie</p>
                                </div>
                                <div className="col-lg-8">
                                    <select value={combo.tipoMascota} onChange={(e)=>{setCombo({...combo, tipoMascota: e.target.value}); getRazas(e.target.value); setListErrors(listErrors.filter( prev => prev !== "tipoMascota" ) )    }} className={`form-control col-lg-12 ${ listErrors.includes("tipoMascota") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                            {species.map(data => (
                                                <option key={data} value={data}>{data}</option>
                                            ))}
                                        <option value="Todos">Todos</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("tipoMascota") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            { razas.length > 0 && <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                <div className="col-lg-3">
                                    <p className="creation-input-label">Raza</p>
                                </div>
                                <div className="col-lg-8">
                                    <select value={combo.dirigido} onChange={(e)=>{setCombo({...combo, dirigido: e.target.value})}} className={`form-control col-lg-12`}>
                                        <option value="">Selección</option>
                                        {razas.map((data, i) => (
                                            <option key={i} value={data}>{data}</option>
                                        ))}
                                    </select>
                                </div>
                            </div> }

                        </div>
                    </div>

                </div>
                <div className="col-lg-4 pl-4">
                    
                    <div className="creation-card mb-5 p-3">
                        <div className="creation-card-content">
                            <div className="position-relative">
                                <input type="file" ref={hiddenFileInput} onChange={handleChange}  style={{display: 'none'}} />
                                <div onClick={handleClick} className={`creation-input-photo ${ listErrors.includes("img") && "border-danger" }`}>
                                {src !== "" ? <img src={src} alt="" /> : <img src={combo.urlImagen} alt="" />}
                                </div>
                                <div style={{textAlign: "center", width: "100%"}}>
                                    <p style={{fontSize: "13px", color: "#a3a6af"}} className="my-3">Dimensiones recomendadas (200 x 300)</p>
                                </div>
                            </div>
                            
                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Título</p>
                                </div>
                                <div className="col-lg-12">
                                    <input value={combo.titulo} onChange={(e)=>{setCombo({...combo, titulo: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "titulo" ) )  }} placeholder="Título del combo" className={`form-control col-lg-12 ${ listErrors.includes("titulo") && "border-danger" } `}/>
                                </div>
                                 <div className="creation-errors-container">
                                    {listErrors.includes("titulo") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>

                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Descripción</p>
                                </div>
                                <div className="col-lg-12">
                                    <textarea value={combo.descripcion} onChange={(e)=>{setCombo({...combo, descripcion: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "descripcion" ) )  }} placeholder="Descripción del combo" className={`form-control col-lg-12 ${ listErrors.includes("descripcion") && "border-danger" } `}/>
                                </div>
                                 <div className="creation-errors-container">
                                    {listErrors.includes("descripcion") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )

}

export default DetailCombo
